import React from 'react'
import { Link } from "react-router-dom";
import Paper from '@mui/material/Paper';
import EditIcon from '@mui/icons-material/Edit';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, IconButton } from '@mui/material';

const columns = [
    { id: 'Address', label: 'Address',minWidth:150},
    { id: 'EnglishText', label: 'English Text',minWidth:150},
    { id: 'PGN', label: 'PGN',minWidth:150},
    { id: 'SPN', label: 'SPN',minWidth:150},
    { id: 'Persistent', label: 'Persistent',minWidth:150},
    { id: 'actions', label: 'Actions' ,minWidth:150},
];

const MessageTable = ({
    page,
    rowsPerPage,
    messageData,
    handleChangePage,
    handleChangeRowsPerPage
}) => {
    
    return (
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            <TableContainer className='TableVirtuoso' sx={{ maxHeight: "100vh" }}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell
                                    key={column.id}
                                    align={column.align}
                                    style={{ minWidth: column.minWidth }}
                                >
                                    {column.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {messageData?.data?.length > 0 ? messageData?.data.map((row,i) => {
                            return (
                                <TableRow hover role="checkbox" tabIndex={-1} key={i}>
                                    {columns?.map((column) => {
                                        const value = row[column.id];
                                        return (
                                            <TableCell key={column.id} align={column.align}>
                                                {column?.format && typeof value === 'number'
                                                    ? column.format(value) 
                                                    : column.id === 'actions' ? 
                                                    <>  
                                                        <IconButton 
                                                            component={Link} 
                                                            color="inherit" 
                                                            title="Edit Receive Message"
                                                            to="/can/receive-messages/edit"
                                                            state={{ addressId : row.Address}}
                                                        >
                                                            <EditIcon />
                                                        </IconButton>
                                                    </>
                                                    : value 
                                                }
                                            </TableCell>
                                        );
                                    })}
                                </TableRow>
                            );
                        }) : <TableRow><TableCell colSpan={3}>No Data Available. </TableCell></TableRow>}
                    </TableBody>
                </Table>
            </TableContainer>
            {messageData?.total > 0  ? 
                <TablePagination
                    rowsPerPageOptions={[100, 200, 500, 1000]}
                    component="div"
                    count={messageData?.total}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage} 
                />
                : <></>
            }
        </Paper> 
    )
}

export default MessageTable